import {Pipe, PipeTransform} from '@angular/core';
import Order from '../../_entities/orders/order.entity';
import {StatesHelper} from '../../states/states.helper';

@Pipe({
    name: 'openOrdersOfStore',
    pure: true
})
export class OpenOrdersOfStorePipe implements PipeTransform {
    transform(storeId: number): Order[] {
        return StatesHelper.ordersEntitiesState.storeIdToOpenOrdersMap.entities[storeId];
    }
}
